import React from 'react';
import { Parameter } from '../../types/schema';
import ParameterTreeNode from '../schema/ParameterTreeNode';
import SchemaParameterTreeView from './SchemaParameterTreeView'; // Import the custom view
import { SchemaProperty } from '@/utils/playbookSchemaUtils'; // Import SchemaProperty

interface SchemaTreeViewProps {
  parameters: Parameter[];
  toggleTreeNode: (path: string, type: 'global' | 'eventSpecific') => void;
  expandedPaths: Set<string>;
  allEvents: any[];
  selectedEventId?: string; // Add selectedEventId prop
  onPropertyClick?: (property: SchemaProperty) => void; // Update onPropertyClick prop type
  onCreateTransform?: (transformType: 'mapping' | 'enrichment' | 'expression' | 'spreading', propertyPath: string, isInputSchema: boolean) => void;
  currentSchemaView?: 'input' | 'output' | 'yaml';
  selectedSection?: 'global' | 'event' | 'connection';
}

const SchemaTreeView: React.FC<SchemaTreeViewProps> = ({
  parameters,
  toggleTreeNode,
  allEvents,
  selectedEventId, // Destructure selectedEventId
  onPropertyClick, // Destructure onPropertyClick
  onCreateTransform,
  currentSchemaView,
  selectedSection,
}) => {
  // Create a dummy map for the tree node component
  const nodesMap = new Map<string, Parameter>();
  parameters.forEach(param => nodesMap.set(param.fullPath, param));

  // The parameters are already filtered by status in the parent component (PlaybookSchemaPreviewPanel)
  // We should not apply additional filtering here that could override the status filtering
  // The event-specific filtering should have been handled in the parent component
  const filteredParameters = parameters;
  
  return (
    <div className="py-4">
      {filteredParameters.map(param => (
        <ParameterTreeNode
          key={param.fullPath} // Use fullPath as key for stable React keys
          param={param}
          scopeType="global"
          allNodesMap={nodesMap}
          toggleTreeNode={toggleTreeNode}
          selectedEvent={null} // This might need to be updated if ParameterTreeNode needs the actual event object
          handleParameterChange={() => {}}
          handleDeleteParameter={() => {}}
          handleAddParameter={() => {}}
          isEditable={false} // Ensure editing is disabled for schema preview
          paramToEditId={null}
          clearParamToEditId={() => {}}
          activeEditingParamId={null}
          setActiveEditingParamId={() => {}}
          allEvents={allEvents}
          handleParameterAssociationChange={() => {}}
          viewMode="tree"
          CustomContentComponent={SchemaParameterTreeView} // Pass our custom content component
          CustomContentComponentProps={{ 
            onPropertyClick,
            onCreateTransform,
            currentSchemaView,
            selectedSection,
            selectedEventId // Pass selectedEventId to the custom component
          }} // Pass all props to the custom component
        />
      ))}
    </div>
  );
};

export default SchemaTreeView;
